import request from '@/utils/request.js';
// 获取微信授权信息
export const getAccessToken = data =>
  request({
    url: '/v1/user/wx_login',
    method: 'post',
    data,
  });
// 获取用户信息
export const getUserInfo = () => request({ url: '/v1/user/get_info', method: 'get' });
// 获取jssdk签名
export const getSign = params =>
  request({
    url: '/v1/wx/sign',
    method: 'get',
    params,
  });
// 用户论坛注册
export const modifyUserInfo = data =>
  request({
    url: '/v1/forum_user/register',
    method: 'post',
    data,
  });
// 上传图片
export const upload = data =>
  request({
    url: '/v1/file/upload',
    method: 'post',
    data,
    showToast: true,
  });
// 修改昵称
export const setUsername = data =>
  request({ url: '/v1/forum_user/update_name', method: 'post', data });
// 修改个性签名
export const setMotto = data =>
  request({ url: '/v1/forum_user/update_motto', method: 'post', data });
// 修改论坛头像
export const setAvatar = data =>
  request({
    url: '/v1/forum_user/update_image',
    method: 'post',
    data,
  });
// 注销用户绑定的游戏账号
export const cancelGameAccount = data =>
  request({ url: '/platform/v1/user/cancel_game_account', method: 'post', data });
